import { Calculator, LineChart, Sprout, Wheat, type LucideIcon } from 'lucide-react';

// Páginas públicas que traen gente desde Google. Una sola lista para la barra y
// el pie, así ninguna queda sin link (Google las encuentra siguiendo estos links).

export interface PublicLink {
  to: string;
  label: string;
  desc?: string;
  Icon?: LucideIcon;
}

export const CALCULADORAS: PublicLink[] = [
  { to: '/calculadora-engorde', label: 'Calculadora de engorde', desc: 'Margen y costo por kilo ganado', Icon: Sprout },
  { to: '/calculadora-racion', label: 'Calculadora de ración', desc: 'Consumo y costo de la dieta', Icon: Wheat },
  { to: '/calculadora-inventario', label: 'Calculadora de inventario', desc: 'Cuánto vale tu rodeo hoy', Icon: Calculator },
];

export const PRECIOS: PublicLink[] = [
  { to: '/precios', label: 'Precio de la hacienda', desc: 'Cañuelas por categoría', Icon: LineChart },
  { to: '/historico-precios', label: 'Histórico de precios' },
];

export const SITIO: PublicLink[] = [
  { to: '/funcionalidades', label: 'Funcionalidades' },
  { to: '/recursos', label: 'Planillas' },
  { to: '/planes', label: 'Planes' },
  { to: '/blog', label: 'Blog' },
  { to: '/foro', label: 'Foro' },
];
